var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{class:'text-' + _vm.statusColor},[_vm._v(" "+_vm._s(_vm._f("formatDate")(_vm.returnDate))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }